module.exports = __webpack_public_path__ + "img/4.d626e94d.png";